import { DEFAULT_LANG, DEFAULT_MARKET } from '@rcg/ui-react';

/**
 * Maps a g11n v1 locale onto the flat payload shape ui-react's useGlobal() reads. Keeping that
 * shape is what lets the 61 useGlobal() call sites stay untouched.
 */
export const mapLocaleToGlobalPayload = (locale, i18nConversion = {}) => {
  const language = locale?.language?.code || DEFAULT_LANG;
  // Underscore form ('es_VE') — how the AEM i18nConversion map is keyed.
  const localeCode = locale?.code;
  const conversion = (localeCode && i18nConversion[localeCode]) || undefined;

  return {
    // Non-URL logic only (allowedMarkets, analytics) — marketPath drives paths.
    market: locale?.market?.code || DEFAULT_MARKET,
    // useGlobal() surfaces `code` as `country`: the isoAlpha3 country, not the market.
    code: locale?.country?.code || '',
    language,
    // g11n only fills the root currency once a country/language pair resolves.
    selectedCurrency: locale?.currency?.code || locale?.country?.defaultCurrency?.code,
    isoAlpha2Code: locale?.country?.isoAlpha2Code,
    // esl.office, not country.office.
    officeCode: locale?.esl?.office?.code,
    // getLocalizedDayjs requires dayjs/locale/{dayJSLangCode}.js and silently falls back to
    // English when absent, so only feed it values AEM has vouched for.
    dayJSLangCode: conversion?.dayjsLocale || language,
    locale: localeCode,
    // The URL prefix the brand's site publishes.
    marketPath: locale?.market?.marketPath,
  };
};

// i18nConversion first (preserving legacy behaviour exactly), then g11n's aem.i18nCode.
export const resolveDictionaryLang = (locale, i18nConversion = {}) => {
  const language = locale?.language?.code || DEFAULT_LANG;
  const conversion = (locale?.code && i18nConversion[locale.code]) || undefined;
  return conversion?.aemDictionary || locale?.aem?.i18nCode || language;
};

export default mapLocaleToGlobalPayload;
